import type { CSSProperties } from 'styled-components';

type KebabCaseFromCamelCase<S extends string> = S extends `${infer TFirstChar}${infer TRest}`
  ? TFirstChar extends Uppercase<TFirstChar>
    ? `-${Lowercase<TFirstChar>}${KebabCaseFromCamelCase<TRest>}`
    : `${TFirstChar}${KebabCaseFromCamelCase<TRest>}`
  : S;

type KebabCSSProperties = {
  [K in keyof CSSProperties as KebabCaseFromCamelCase<K>]: CSSProperties[K];
};

export const rtlPropertiesMixin = (properties: Partial<KebabCSSProperties>) => `
  [dir="rtl"] & {
    /*! @noflip */
    ${Object.entries(properties)
      .map(([prop, value]) => `${prop}: ${value};`)
      .join('\n')}
  }
`;
